import clsx from 'clsx';
import { Button, Stack, Text } from 'components';
import { expandAiScribeDrawer } from 'store/clients/clientsSlice';
import { useAppDispatch, useAppSelector } from 'store/hooks';

import { formatDuration, PauseIcon, MicrophoneIcon } from '../expanded/expanded';
import { useAiScribeContext } from '../expanded/useAiScribe';
import style from './collapsed.module.scss';

const CollapsedDrawer = () => {
  const { clientName, duration, isPaused, error } = useAppSelector((s) => s.clients.aiScribe);
  const dispatch = useAppDispatch();

  const { pauseRecording, resumeRecording } = useAiScribeContext();

  const handlePauseResume = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent drawer from expanding when clicking pause/resume
    if (isPaused) {
      resumeRecording();
    } else {
      pauseRecording();
    }
  };

  return (
    <Stack
      onClick={() => dispatch(expandAiScribeDrawer())}
      position="fixed"
      bottom={0}
      left={0}
      px="16px"
      width="100%"
      display="flex"
      flexDirection="row"
      alignItems="center"
      height="88px"
      bgcolor="white"
      boxShadow="0px -8px 40px 0px #0D1C3014, 0px 2px 1px 0px #00000008"
      zIndex={1000}
      boxSizing="border-box"
    >
      <Stack
        width="100%"
        mr="80px"
        display="flex"
        flexDirection="row"
        alignItems="center"
        gap="12px"
        justifyContent="space-between"
        minWidth="0px"
        boxSizing="border-box"
      >
        <Stack
          display="flex"
          flexDirection="row"
          alignItems="center"
          gap="12px"
          overflow="hidden"
          flexGrow={1}
          boxSizing="border-box"
        >
          <Button
            icon={isPaused ? <MicrophoneIcon /> : <PauseIcon />}
            theme={isPaused ? 'green' : 'warning'}
            shape="circle"
            handleOnClick={handlePauseResume}
          />
          <Text
            size="large"
            weight="semibold"
            style={{
              overflow: 'hidden',
              minWidth: '0px',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            {clientName}
          </Text>
        </Stack>
        <Stack display="flex" flexDirection="row" alignItems="center" gap="8px">
          {error && <span className={clsx('material-icons', style.errorIcon)}>error_outline</span>}
          <div className={style.duration}>{formatDuration(duration)}</div>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default CollapsedDrawer;
